import { render, staticRenderFns } from "./DeckProductSelector.vue?vue&type=template&id=df1add18&"
import script from "./DeckProductSelector.vue?vue&type=script&lang=js&"
export * from "./DeckProductSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports